import script from "./ArticlesFormPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticlesFormPage.vue?vue&type=script&setup=true&lang=js"

import "./ArticlesFormPage.vue?vue&type=style&index=0&id=40257fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40257fd0"]])

export default __exports__